var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 56C0 70.8521 5.89998 85.0959 16.402 95.598C26.9041 106.1 41.1479 112 56 112C70.8521 112 85.0959 106.1 95.598 95.598C106.1 85.0959 112 70.8521 112 56C112 41.1479 106.1 26.9041 95.598 16.402C85.0959 5.89998 70.8521 0 56 0C41.1479 0 26.9041 5.89998 16.402 16.402C5.89998 26.9041 0 41.1479 0 56Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 89.4924C19.5469 90.1649 23.2872 90.8097 29.9449 91.2852C36.6027 91.7607 45.6326 92.0278 55.0481 92.0278C64.4636 92.0278 73.4935 91.7607 80.1512 91.2852C86.809 90.8097 90.5493 90.1649 90.5493 89.4924C90.5493 88.82 86.809 88.1751 80.1512 87.6996C73.4935 87.2242 64.4636 86.957 55.0481 86.957C45.6326 86.957 36.6027 87.2242 29.9449 87.6996C23.2872 88.1751 19.5469 88.82 19.5469 89.4924Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7848 79.0859H16.3922C16.0209 79.0859 15.6648 79.2334 15.4022 79.496C15.1397 79.7585 14.9922 80.1146 14.9922 80.4859V85.3285H97.1848V80.4859C97.1848 80.1146 97.0373 79.7585 96.7747 79.496C96.5122 79.2334 96.1561 79.0859 95.7848 79.0859Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1848 85.3281H14.9922C15.6177 86.5789 16.5791 87.6307 17.7687 88.3658C18.9583 89.101 20.3292 89.4903 21.7276 89.4903H90.483C91.871 89.4896 93.2315 89.1028 94.4123 88.3732C95.5931 87.6436 96.5477 86.5999 97.1694 85.3589L97.1848 85.3281Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1425 35.3906H24.0351C23.2925 35.3906 22.5803 35.6856 22.0552 36.2107C21.5301 36.7358 21.2351 37.448 21.2351 38.1906V79.0874H90.9425V38.1906C90.9425 37.448 90.6475 36.7358 90.1224 36.2107C89.5973 35.6856 88.8851 35.3906 88.1425 35.3906Z",
    fill: "#F7CA50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1425 35.3906H24.0351C23.2925 35.3906 22.5803 35.6856 22.0552 36.2107C21.5301 36.7358 21.2351 37.448 21.2351 38.1906V79.0874H90.9425V38.1906C90.9425 37.448 90.6475 36.7358 90.1224 36.2107C89.5973 35.6856 88.8851 35.3906 88.1425 35.3906Z",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7133 24.3656C69.0787 24.3646 69.4364 24.2615 69.7463 24.068C70.0561 23.8744 70.3057 23.5982 70.4669 23.2703C70.628 22.9424 70.6943 22.5761 70.6583 22.2125C70.6223 21.849 70.4855 21.5027 70.2631 21.2128L57.6379 4.84124C57.4547 4.60492 57.2199 4.41363 56.9514 4.28204C56.6829 4.15045 56.3878 4.08203 56.0888 4.08203C55.7898 4.08203 55.4948 4.15045 55.2263 4.28204C54.9578 4.41363 54.7229 4.60492 54.5397 4.84124L41.9145 21.2058C41.6902 21.4957 41.5516 21.8426 41.5145 22.2073C41.4774 22.5719 41.5433 22.9397 41.7047 23.2687C41.8661 23.5978 42.1165 23.8751 42.4276 24.0689C42.7386 24.2628 43.0978 24.3656 43.4643 24.3656H48.2607V40.9934C48.2607 42.0331 48.6737 43.0302 49.4089 43.7653C50.144 44.5004 51.1411 44.9134 52.1807 44.9134H60.0081C61.0478 44.9134 62.0448 44.5004 62.78 43.7653C63.5151 43.0302 63.9281 42.0331 63.9281 40.9934V24.3656H68.7133Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7133 24.3656C69.0787 24.3646 69.4364 24.2615 69.7463 24.068C70.0561 23.8744 70.3057 23.5982 70.4669 23.2703C70.628 22.9424 70.6943 22.5761 70.6583 22.2125C70.6223 21.849 70.4855 21.5027 70.2631 21.2128L57.6379 4.84124C57.4547 4.60492 57.2199 4.41363 56.9514 4.28204C56.6829 4.15045 56.3878 4.08203 56.0888 4.08203C55.7898 4.08203 55.4948 4.15045 55.2263 4.28204C54.9578 4.41363 54.7229 4.60492 54.5397 4.84124L41.9145 21.2058C41.6902 21.4957 41.5516 21.8426 41.5145 22.2073C41.4774 22.5719 41.5433 22.9397 41.7047 23.2687C41.8661 23.5978 42.1165 23.8751 42.4276 24.0689C42.7386 24.2628 43.0978 24.3656 43.4643 24.3656H48.2607V40.9934C48.2607 42.0331 48.6737 43.0302 49.4089 43.7653C50.144 44.5004 51.1411 44.9134 52.1807 44.9134H60.0081C61.0478 44.9134 62.0448 44.5004 62.78 43.7653C63.5151 43.0302 63.9281 42.0331 63.9281 40.9934V24.3656H68.7133Z",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.218 49.0898H61.9598V54.96H50.218V49.0898Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1953 58.875H60.9799V64.7452H51.1953V58.875Z",
    fill: "white",
    stroke: "#0E2032",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.cbe8ae9ed370a1b3d14a43bd1536adaa.svg";
export { ForwardRef as ReactComponent };